var map = new google.maps.Map(document.getElementById('map-canvas'), {
  center: new google.maps.LatLng(-28, 135),
  mapTypeId: google.maps.MapTypeId.ROADMAP,
  styles: [
      {"elementType": "geometry.fill","stylers": [{"color": "#f3f2f2"}]},
      {"featureType": "administrative.country","elementType": "labels.text.fill","stylers": [{"color": "#adadad"}]},
      {"featureType": "landscape.natural.landcover","elementType": "geometry.fill","stylers": [{"color": "#f9f9f9"}]},
      {"featureType": "water","elementType": "geometry.fill","stylers": [{"color": "#bfedfe"}]}
  ]
});

var panelDiv = document.getElementById('panel');

var data = new UnicoDataSource;

var view = new storeLocator.View(map, data, {
  geolocation: false,
  features: data.getFeatures()
});

new storeLocator.Panel(panelDiv, {
  view: view
});


if ($(window).width() <= 991 ) {
  map.setZoom(4);
  if ($(window).width() <= 450 ) {map.setZoom(3);}
} else {
  map.setZoom(5);
}

google.maps.event.addDomListener(window, 'resize', function() {
  if ($(window).width() <= 991 ) {
    map.setZoom(4);
  } else {
    map.setZoom(5);
  }
});

var _gaq = _gaq || [];
_gaq.push(['_setAccount', 'UA-12846745-20']);
_gaq.push(['_trackPageview']);

(function() {
var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
ga.src = ('https:' === document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
})();